const Events = (state = {}, action) => {
  switch (action.type) {
    case 'GET_EVENTS_SUCCESS':
      return {
        ...state,
        list: action.data
      }
    case 'GET_EVENT_SUCCESS':
      return {
        ...state,
        show: action.data
      }
    case 'CREATE_EVENT_SUCCESS':
      return {
        ...state,
        show: action.data
      }
    case 'UPDATE_EVENT_SUCCESS':
      return {
        ...state,
        show: action.data
      }
    case 'DELETE_EVENT_SUCCESS':
      return {
        ...state,
        show: null,
        list: state.list
          ? {
              ...state.list,
              rows: (state.list.rows || []).filter(e => e.id !== action.data.id)
            }
          : state.list
      }
    default:
      return state
  }
}

export default Events
